import { SubAgentAvatar } from './sub-agent-avatar';

export const SUB_AGENT_AVATAR_STRIP_LIMIT = 4;

/**
 * Working avatars for in-flight workers, in the given order, with an overflow
 * count. Shared by the activity cluster header and the group header so one
 * worker keeps one avatar across both. `workers` may be a loaded sample;
 * `total` is the true in-flight count and drives the overflow.
 */
export function SubAgentAvatarStrip({
  workers,
  total = workers.length,
}: {
  workers: ReadonlyArray<{ identity: string }>;
  total?: number;
}) {
  const shown = Math.min(workers.length, SUB_AGENT_AVATAR_STRIP_LIMIT);
  const overflow = Math.max(total, workers.length) - shown;
  return (
    <span
      data-cluster-active-workers
      className="inline-flex shrink-0 items-center gap-1"
    >
      {workers.slice(0, SUB_AGENT_AVATAR_STRIP_LIMIT).map((worker) => (
        <SubAgentAvatar
          key={worker.identity}
          identity={worker.identity}
          working
        />
      ))}
      {overflow > 0 ? <span className="text-xs">+{overflow}</span> : null}
    </span>
  );
}
